module.exports = __webpack_public_path__ + "static/media/Calibre-Light.73b7f438.ttf";